<script>
import ComCheck from './check.component.vue';
import ComDatepicker from './datepicker.component.vue';
import ComDate from './date.component.vue';
import ComDictionary from './dictionary.component.vue';
import ComEditor from './editor.component.vue';
import ComGender from './gender.component.vue';
import ComMask from './mask.component.vue';
import ComNumber from './number.component.vue';
import ComPassword from './password.component.vue';
import ComPhone from './phone.component.vue';
import ComPrice from './price.component.vue';
import ComText from './text.component.vue';
import ComSelect from './select.component.vue';
import ComTouristfio from './touristFio.component.vue';

export default {
  name: 'UlFormItem',
  components: {
    ComCheck,
    ComDatepicker,
    ComDate,
    ComDictionary,
    ComEditor,
    ComGender,
    ComMask,
    ComNumber,
    ComPassword,
    ComPhone,
    ComPrice,
    ComText,
    ComSelect,
    ComTouristfio,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Boolean,
      default: true,
    },
    fixedLabel: {
      type: Boolean,
      default: false,
    },
    star: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    module: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    icon: {
      type: String,
    },
    width: {
      type: String,
    },
  },
  data: () => ({
    focus: false,
    error: '',
  }),
  computed: {
    place() {
      if (this.fixedLabel || this.icon) {
        return this.placeholder;
      }
      return '';
    },
    value() {
      return this.module.value;
    },
    cls() {
      return {
        [`ul-form-item--${this.module.type}`]: true,
        'ul-form-item--focus': this.focus,
        'ul-form-item--value': this.value || this.module.labelMin,
        'ul-form-item--disabled': this.module.disabled,
        'ul-form-item--focused': this.module.focused,
        'ul-form-item--require': this.module.require,
        'ul-form-item--error': !!this.module.error,
        'ul-form-item--fixed-label': !!this.fixedLabel,
        'ul-form-item--shrink': !!this.width,
      };
    },
    styles() {
      return {
        width: this.width || '100%',
      };
    },
    load() {
      return this.module.loading || this.loading;
    },
    com() {
      return `com-${this.module.type}`;
    },
    lbl() {
      return this.label || this.module.label || '';
    },
  },
  methods: {
    clickLabel() {
      const el = this.$el.querySelector('input');
      if (el) {
        el.focus();
      }
    },
    focusEv(e) {
      this.focus = true;
      this.$emit('focus', e);
    },
    inputEv(e) {
      this.$emit('input', e);
      this.validate();
    },
    changeEv(e) {
      this.$emit('change', e);
      this.validate();
    },
    blurEv(e) {
      this.focus = false;
      this.module.focused = true;
      this.$emit('blur', e);
      this.validate();
    },
    validate() {
      this.module.valid()
        .catch(() => {
        });
    },
  },
  mounted() {
    this.module.show = true;
  },
  destroyed() {
    this.module.show = false;
  },
};
</script>
<template>
  <div
    class="ul-form-item"
    :class="cls"
    :style="styles"
  >
    <label
      class="ul-form-item__label"
      @click="clickLabel"
      v-if="!icon&&lbl"
    >
      <slot name="label">
        {{lbl}}
      </slot>
      <i class="el-icon-loading" v-if="module.loading"></i>
    </label>
    <div class="ul-form-item__body">
      <div class="ul-form-item__input">
        <div
          v-if="icon"
          class="ul-form-item__icon"
          :title="label || ''"
        >
          <i :class="icon"></i>
        </div>
        <component
          :is="com"
          class="ul-form-item__com"
          :module="module"
          :disabled="disabled"
          @input="inputEv"
          @change="changeEv"
          @focus="focusEv"
          @blur="blurEv"
          @submit="$emit('submit')"
          :placeholder="place"
        >
          <slot></slot>
        </component>
        <div class="ul-form-item__pre">
          <slot name="prepend"></slot>
        </div>
      </div>
      <div class="ul-form-item__border"></div>
    </div>
    <div class="ul-form-item__error">
      {{module.error | lang}}
    </div>
  </div>
</template>
<style lang="scss">
  .ul-form-item {
    display: block;
    margin: 0;
    position: relative;
    padding: 0;

    &__label {
      color: #777777;
      position: absolute;
      top: 0;
      font-size: 16px;
      transition: padding-top .2s, font-size .2s;
      padding: 17px 0 0 0;
      line-height: 22px;
      cursor: auto;
      z-index: 1;
    }

    &__body {
      padding: 16px 0 12px 0;
      position: relative;
    }

    &__pre {
      flex-shrink: 0;
    }

    &__icon {
      flex-shrink: 0;
      width: 32px;
      text-align: center;
      color: #777777;
      font-size: 18px;
    }

    &__input {
      align-items: center;
      display: flex;
      font-size: 16px;
      justify-content: space-between;
      padding: 0;
    }

    &__com {
      flex-grow: 1;
    }

    &__border {
      background: #999999;
      width: 100%;
      height: 1px;
      position: absolute;
      bottom: 13px;


      &::before {
        background: #1b2f3f;
        content: '';
        position: absolute;
        height: 2px;
        width: 0;
        left: 50%;
        top: 0;
        transition: .2s;
      }
    }

    &__error {
      color: #ee1111;
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 11px;
      display: none;
    }

    &--focus {
      .ul-form-item__label {
        color: #1b2f3f;
      }

      .ul-form-item__border {
        &::before {
          transform: translate(-50%, 0);
          width: 100%;
        }
      }
    }

    &--value,
    &--focus {
      .ul-form-item__label {
        font-size: 13px;
        padding-top: 2px;
        left: 0;
        line-height: 14px;
      }
    }

    &--disabled {
      cursor: default;

      .ul-form-item__label {
        cursor: default;
      }

      .ul-form-item__com {
        cursor: default;
      }

      .ul-form-item__border {
        background: #dddddd;
      }
    }

    &--focused.ul-form-item--error {
      .ul-form-item__border {
        background: #ee1111;
        height: 2px;

        &:before {
          content: none;
        }
      }

      .ul-form-item__label {
        color: #ee1111;
      }

      .ul-form-item__error {
        display: block;
      }
    }

    input {
      font-weight: 500 !important;
      color: #333 !important;
    }
  }

  .ul-form-item--flex {
    display: flex;
  }

  .ul-form-item--check {
    .ul-form-item__border {
      display: none;
    }
  }

  .ul-form-item--shrink {
    flex-shrink: 0;
  }

  .ul-form-item--fixed-label,
  .ul-form-item--price,
  .ul-form-item--number,
  .ul-form-item--check {
    .ul-form-item__label {
      font-size: 13px;
      padding-top: 2px;
      left: 0;
      line-height: 14px;
    }
  }
</style>
